export default "__VITE_ASSET__BsEKfaB$__"